import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description = '', 
  keywords = '',
  canonicalUrl = '',
  ogImage = '',
  ogType = 'website',
  ogTitle = '',
  ogDescription = '',
  noIndex = false
}) => {
  const siteUrl = 'https://staymii.com';
  const pageTitle = title ? title + ' | StayMii' : 'StayMii — E-Invoicing & Compliance for Hotels | Malaysia';
  const pageUrl = canonicalUrl ? siteUrl + canonicalUrl : siteUrl;
  const finalOgImage = ogImage || 'https://staymii.com/og-image.jpg';
  const finalOgTitle = ogTitle || pageTitle;
  const finalOgDescription = ogDescription || description;
  
  useEffect(() => {
    // Update document title
    document.title = pageTitle;
    
    // Update or create meta tags
    const updateMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    
    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', pageUrl);
    
    // Robots meta - noindex for auth/admin pages
    updateMeta('robots', noIndex ? 'noindex, nofollow' : 'index, follow');
    
    // Primary meta tags
    updateMeta('description', description);
    if (keywords) updateMeta('keywords', keywords);
    
    // Open Graph
    updateMeta('og:type', ogType, true);
    updateMeta('og:url', pageUrl, true);
    updateMeta('og:title', finalOgTitle, true);
    updateMeta('og:description', finalOgDescription, true);
    updateMeta('og:image', finalOgImage, true);
    updateMeta('og:image:secure_url', finalOgImage, true);
    updateMeta('og:image:width', '1200', true);
    updateMeta('og:image:height', '630', true);
    
    // Twitter
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:url', pageUrl);
    updateMeta('twitter:title', finalOgTitle);
    updateMeta('twitter:description', finalOgDescription);
    updateMeta('twitter:image', finalOgImage);
    
  }, [pageTitle, description, keywords, pageUrl, noIndex, finalOgImage, ogType, finalOgTitle, finalOgDescription]);
  
  return null;
};

export default SEO;
